import { render } from "./EditSubscriber.vue?vue&type=template&id=04b94806&scoped=true"
import script from "./EditSubscriber.vue?vue&type=script&lang=js"
export * from "./EditSubscriber.vue?vue&type=script&lang=js"

import "./EditSubscriber.vue?vue&type=style&index=0&id=04b94806&scoped=true&lang=css"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b94806"]])

export default __exports__